import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import { DEALER_DELETE, DEALER_LIST } from "../actions/dealer.actions.types";

const call = Effects.call;

function* getDealerList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "dealer/dealer-request/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteDealer({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `dealer/dealer-request/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Dealer() {
  yield all([
    takeLatest(DEALER_LIST, getDealerList),
    takeLatest(DEALER_DELETE, deleteDealer),
  ]);
}

export default Dealer;
